import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  apiPassword,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, apiPassword] as const
const locationCredentialTypes = [accountNumber] as const

export type hwepCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const hwepDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const hwep: CarrierDef<hwepCredType> = {
  name: 'Rist Transport LTD',
  scac: 'hwep',
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['api-password', 'apiPassword'],
    ['account-number', 'ref1'],
  ],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: hwepDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
